import {
	IconCircleCheckOutline18,
	IconCircleHalfDottedClockOutline18,
	IconUserArrowRightOutline18,
} from "nucleo-ui-outline-18"

export type AgentBucket = "resolved" | "pending" | "escalated"

// What needs a teammate leads, and the columns end on the outcome we want.
export const AGENT_BUCKETS: readonly AgentBucket[] = [
	"escalated",
	"pending",
	"resolved",
]

const BUCKET_COLUMNS = {
	pending: { label: "Pending", icon: IconCircleHalfDottedClockOutline18 },
	escalated: { label: "Escalated", icon: IconUserArrowRightOutline18 },
	resolved: { label: "Resolved", icon: IconCircleCheckOutline18 },
} as const

export const agentBucketColumns = AGENT_BUCKETS.map((bucket) => ({
	bucket,
	...BUCKET_COLUMNS[bucket],
}))

// Each column carries the colour of its outcome: a handoff reads a muted red, since
// some always happen; a self-resolved session green; in flight stays grey.
export const agentBucketIconClassName = (bucket: AgentBucket) => {
	switch (bucket) {
		case "escalated":
			return "text-red-400 dark:text-red-400/80"
		case "resolved":
			return "text-green-600 dark:text-green-500"
		default:
			return "text-tertiary"
	}
}

export const agentBucketHeaderClassName = (bucket: AgentBucket) => {
	switch (bucket) {
		case "escalated":
			return "bg-red-50/60 dark:bg-red-500/5"
		case "resolved":
			return "bg-green-50 dark:bg-green-500/10"
		default:
			return "bg-gray-100 dark:bg-gray-850"
	}
}

export const groupByAgentBucket = <T extends { bucket: AgentBucket }>(
	entries: readonly T[],
): Record<AgentBucket, T[]> => {
	const columns: Record<AgentBucket, T[]> = {
		resolved: [],
		pending: [],
		escalated: [],
	}
	for (const entry of entries) columns[entry.bucket].push(entry)
	return columns
}
